import { render } from "./LineInfoTable.vue?vue&type=template&id=b067c098"
import script from "./LineInfoTable.vue?vue&type=script&lang=js"
export * from "./LineInfoTable.vue?vue&type=script&lang=js"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__